import React from 'react';

export default function useIsMounted() {
  const componentIsMounted = React.useRef(true);

  React.useEffect(() => () => { componentIsMounted.current = false; }, []);

  return componentIsMounted;
}
